import React, { useState } from "react";
import { Outlet } from "react-router-dom";

const DeviceContext = React.createContext(null);

export const useDeviceContext = () => {
  return React.useContext(DeviceContext);
};

function DeviceDataProvider() {
  const [refreshFlag, setRefreshFlag] = useState(false);


  return (
      <DeviceContext.Provider 
    value={{ 
      RefreshFlag: refreshFlag,
      SetRefreshFlag: setRefreshFlag,
    }}>
      <Outlet />
    </DeviceContext.Provider>
  );
}

export default DeviceDataProvider;
